module.exports = __webpack_public_path__ + "assets/img/DJ-Coaching.55b65f75.png";